import React, { useState } from "react";
import { Check, Copy } from "lucide-react";

interface SpecRowProps {
  label: string;
  value: React.ReactNode;
}

export function SpecRow({ label, value }: SpecRowProps) {
  return (
    <tr>
      <th
        scope="row"
        className="h-11 w-2/5 px-3 py-2 text-left text-xs font-medium text-zinc-500"
      >
        {label}
      </th>
      <td className="h-11 px-3 py-2 text-sm text-zinc-300">
        <div className="flex h-full min-w-0 items-center">{value}</div>
      </td>
    </tr>
  );
}

interface CopyableSpecValueProps {
  value: string;
  label: string;
}

export function CopyableSpecValue({ value, label }: CopyableSpecValueProps) {
  const [copied, setCopied] = useState(false);

  const copyValue = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 3000);
  };

  return (
    <span className="inline-flex max-w-full items-center gap-1.5">
      <span className="truncate">{value}</span>
      <button
        type="button"
        onClick={copyValue}
        aria-label={`Copy ${label}`}
        title={`Copy ${label}`}
        className="inline-flex size-3.5 shrink-0 items-center justify-center p-0 text-zinc-500 focus-visible:outline-2 focus-visible:outline-highlight"
      >
        {copied ? (
          <Check className="size-3 text-green-400" aria-hidden="true" />
        ) : (
          <Copy className="size-3" aria-hidden="true" />
        )}
      </button>
    </span>
  );
}
